// 项目案例数据 - 完整 9 条，与 PPT《项目案例情况》1:1 顺序对应
export type ProjectCategory = 'ai' | 'cloud' | 'security';

export const CATEGORY_LABEL: Record<ProjectCategory, string> = {
  ai: 'AI',
  cloud: '云计算',
  security: '安全',
};

export interface ProjectCase {
  id: number;
  title: string;
  customer: string;
  year: string;
  scale: string;
  role: string;
  tags: string[];
  productLine: string[];
  category: ProjectCategory;
  highlight: boolean;
  slide: string;
  myContribution: string;
}

export const projectCases: ProjectCase[] = [
  {
    id: 1,
    title: 'XX 头部央企 · AI Coding 项目（公司首单）',
    customer: '央企集团 · KA 客户',
    year: '2025',
    scale: 'AI 研发链首单 · 端到端 AI 研发转型',
    role: '售前主导 · 方案架构师',
    tags: ['AI Coding', 'Agent', '央企', '公司首单', '研发提效'],
    productLine: ['Costrict', 'AICP', 'FastGPT'],
    category: 'ai',
    highlight: true,
    slide: '/images/project-slides/1.jpg',
    myContribution:
      '主导本项目为公司 AI Coding 商业化首单。围绕 XX 集团 AI 研发链目标：把 Costrict 接入集团 AI 研发链，搭建覆盖需求/设计/开发/测试/集成/运维的端到端 AI 研发闭环；规划 IDE→CLI→Web IDE 多入口演进，构建面向研发、产品经理等多角色的统一 AI 研发中台；沉淀「试点—推广—复盘—激励—沉淀—迭代」运营闭环及多维度指标度量体系，让 AI Coding 应用价值可衡量、可呈现、可持续优化。',
  },
  {
    id: 2,
    title: 'XX 头部车企 · 桌面云平台项目（8W 点）',
    customer: '国内头部车企（KA 客户）',
    year: '2 年跟单 · 现落地',
    scale: '一期 8,000 点 · 远期 80,000 点 · 项目规模上亿',
    role: '项目技术整体负责人',
    tags: ['桌面云', '汽车行业', 'KA 客户', '超大规模', '数据防泄密'],
    productLine: ['aDesk', 'aSpace', 'SCP', 'IOM'],
    category: 'cloud',
    highlight: true,
    slide: '/images/project-slides/2.jpg',
    myContribution:
      '作为项目技术整体负责人，主导从整体技术架构设计 → 技术认可 POC → 招投标全流程关键节点，历时 2 年痛点挖掘及 POC 验证。针对客户 3D 设计/渲染核心业务场景，重点突破用户体验（软件打开渲染速度、操作流畅度对标物理机）、数据安全（网络+数据多维防护）、超大规模管理（一期 8000→远期 8W 点）三大关切，最终成功中标；为客户规划全集团数据防泄密架构。',
  },
  {
    id: 3,
    title: 'XX 头部车企 · 云平台超融合替换（1000C）',
    customer: '同集团扩容项目（KA 客户）',
    year: '2024 · 一整年 POC',
    scale: '1000+ 核 · 存算分离 → 超融合架构',
    role: '售前技术方案设计',
    tags: ['超融合', 'HCI', '汽车行业', '架构升级'],
    productLine: ['HCI', 'aCloud'],
    category: 'cloud',
    highlight: true,
    slide: '/images/project-slides/3.jpg',
    myContribution:
      '客户 25 年前从未使用超融合、长期坚持存算分离部署私有云，对超融合架构存在深度怀疑。用一整年时间协调总部专家多次深度技术探讨，主导可靠性/性能测试全流程，针对亚健康检测/HA 迁移影响/性能压测对比等场景用数据展示我司优势，最终在可靠性/管理/性能三维度全面领先友商，打消顾虑成功中标。',
  },
  {
    id: 4,
    title: 'XX 头部车企 · AI 数字客服（共建孵化）',
    customer: '头部车企 · 桌面云 4W+ 存量客户',
    year: '2025',
    scale: '4W+ 桌面云节点 · 日均保障量 1000+ 条',
    role: '售前主导 · AI 场景共建',
    tags: ['AI 数字客服', 'RAG', '桌面云运维', 'ITSM 集成', '共建孵化'],
    productLine: ['FastGPT', 'AICP', 'aDesk'],
    category: 'ai',
    highlight: true,
    slide: '/images/project-slides/4.jpg',
    myContribution:
      '客户 4W+ 桌面云节点、日均保障量峰值 1000+ 条（网络权限/软件配置/使用操作等），传统工单方式覆盖不全。主导构建 AI 数字客服助手方案：定制化集成桌面云客户端一键入口 + 对接内部 ITSM 工作流实现「AI 求助→自助诊断→一键工单→自动化运维→复盘沉淀」闭环；内置桌面云排障知识库并沉淀专家经验，实现团队经验共享；深挖运营数据发现潜在问题（解决率/高频重复问题），从被动响应转主动优化。',
  },
  {
    id: 5,
    title: 'XX 新能源客户 · 分布式云建设（200+ 节点）',
    customer: '头部新能源集团',
    year: '2021 - 至今',
    scale: '全国 200+ 节点 · 覆盖总部与多个生产基地',
    role: '售前架构师 · 长期方案规划',
    tags: ['分布式云', '双活容灾', '新能源', 'VMware 替换', '生产系统'],
    productLine: ['HCI', 'aCloud', 'CDP', 'EDS'],
    category: 'cloud',
    highlight: true,
    slide: '/images/project-slides/5.jpg',
    myContribution:
      '客户 21 年前主要业务基于 VMware 虚拟化，21 年起启动私有云建设逐步替换。主导规划四阶段演进路径：超融合架构云平台 → 延伸集群+AD 园区级生产业务双活 → 集团+生产基地同构分布式云统一管理 → 智能化云平（资源应用统一调度）；推动 WMS/QMS/MES/TSDB 等业务稳定承载，全国规模超 200 节点，运维管理效率提升 40%。',
  },
  {
    id: 6,
    title: 'XX 头部制造业 · 云平台回迁项目（100+ 节点）',
    customer: '大型集团子公司',
    year: '2024',
    scale: '100+ 节点 · 友商私有云 → 深信服私有云回迁',
    role: '售前方案架构师',
    tags: ['云回迁', '异构迁移', '制造业', '成本优化'],
    productLine: ['SANGFOR Cloud', 'HCI', 'DMP', 'CWPP', 'ABDI', '容器安全'],
    category: 'cloud',
    highlight: false,
    slide: '/images/project-slides/6.jpg',
    myContribution:
      '客户原用总公司自建友商私有云承载，子集团复用需按资源结算成本高昂、部分开源组件无兜底方案。主导回迁方案设计：以我司私有云替换友商平台，结合 DMP/CWPP/ABDI/容器安全等 PaaS 层组件替换开源件；通过测试验证降低业务影响后成功回迁。客户获得子集团数据自主权、成本大幅降低、可纳管 VM 平台统一管理。',
  },
  {
    id: 7,
    title: 'XX 制造业 · AI 平台搭建项目',
    customer: '大型制造业集团（董事长层级关注）',
    year: '2025',
    scale: 'Deepseek 671B · 4090D×8 承载',
    role: '售前解决方案工程师（0→1 首单负责人）',
    tags: ['AI 平台', '大模型', 'GPU 管理', 'RAG 知识库', 'MOE'],
    productLine: ['AICP', 'FastGPT', 'GPU 管理平台'],
    category: 'ai',
    highlight: true,
    slide: '/images/project-slides/7.jpg',
    myContribution:
      '客户前期在公有云做算力探索受限，董事长层级关注效果推进本地化 AI 平台。主导整体方案：混合部署架构（MOE 模型特点 + vGPU，模型服务合理分布于显存/内存+CPU 联合计算），GPU 资源规划 4090D×8 集群，多模型协同（Deepseek 671B + QWQ-32B + 多小模型），RAG 知识库应用；打通了在有限预算下运行全量级大模型的工程路径，帮助客户实现「首期低成本高回报」的建设目标。',
  },
  {
    id: 8,
    title: 'XX 头部制造业 · 安全咨询规划项目',
    customer: '深圳重点民营企业集团',
    year: '2022（20 大前后）',
    scale: '集团级 · 涵盖 DMZ / 出口 / 办公 / 核心业务 / 多区域',
    role: '售前方案设计 + 红队攻防演练支持',
    tags: ['安全咨询', '红队', '零信任', 'MSS', '20 大保障'],
    productLine: ['ZTA-SDP', 'ZTA-DGW', 'SIR', 'MSS'],
    category: 'security',
    highlight: false,
    slide: '/images/project-slides/8.jpg',
    myContribution:
      '主导"红队 + 安全咨询规划"组合定制方案。通过攻防演练调研发现暴露面/访问权限不精细等 X 大类 X 小项问题；与客户安全负责人沟通整改建议时挖掘到部分已知安全问题无闭环流程；完成集团高层汇报，集团高层现场称赞红队检测效果及 MSS 值守价值，建议下属十几家子公司选择我司 MSS 作为安全补充能力，推动 ZTA/SIR 平台及年度安全服务落地，红队检测持续带动 KA 客户商机增长。',
  },
  {
    id: 9,
    title: 'XX 头部制造业 · 零信任 & 沙箱三期',
    customer: '集团型企业（KA 客户）',
    year: '2023',
    scale: '三期项目 · 电脑端办公与研发场景',
    role: '售前主导',
    tags: ['零信任', '沙箱', '研发数据流转', '制造业', '技评第一'],
    productLine: ['ZTA-SDP', 'ZTA-DGW', '沙箱'],
    category: 'security',
    highlight: false,
    slide: '/images/project-slides/9.jpg',
    myContribution:
      '客户 21 年初已采购友商沙箱、二期扩容继续使用友商，本次三期主要为电脑端办公和研发提供安全接入和沙箱，用户关注数据流转安全性与接入体验。主导策略：一是以客户需求为导向、协同总部与区域专家成立专项小组、定期对齐需求偏差持续引导我司特色价值功能；二是深入了解客户需求、问题前置——中期阶段即为客户规划详细方案（高可用容灾、研发数据流转管控等），测试技评获第一名，最终成功引导客户采用我方架构作为后续标准方案。',
  },
];
